export type OneVoteVetoController = {
    veto: () => Promise<true | string[]>;
    pass: (redirectUrl?: string) => Promise<true | string[]>;
};

export class OneVoteVeto {
    readonly #controllerPromises: Promise<string | undefined>[] = [];
    readonly #controllers: OneVoteVetoController[] = [];

    constructor(expect: number) {
        Array.from(Array(expect), () => {
            const p = new Promise<string | undefined>((resolve, reject) => {
                this.#controllers.push({
                    pass: (redirectUrl?: string) =>
                        Promise.resolve(resolve(redirectUrl)).then(() => this.isFinalVetoed()),
                    veto: () => Promise.resolve(reject()).then(() => this.isFinalVetoed()),
                });
            });

            this.#controllerPromises.push(p);
        });
    }

    #controllerIndex = 0;

    public getNextController(): OneVoteVetoController {
        return this.#controllers[this.#controllerIndex++];
    }

    public isFinalVetoed(): Promise<true | string[]> {
        return Promise.all(this.#controllerPromises).then(
            data => {
                const ds = data
                    .filter((d): d is string => 'string' === typeof d && d.trim().length > 0)
                    .map(d => d.trim());
                return Array.from(new Set<string>(ds));
            },
            () => true
        );
    }
}
